const state = {
  administrator: 'administrator',
  // 系统管理员
  systemOperator: 'systemOperator',
  // 系统操作员
  systemMonitor: 'systemMonitor',
  // 系统监察员
  corpManager: 'corpManager',
  // 商户管理
  operator: 'operator',
  // 操作员
  monitor: 'monitor',
  // 监察员
  handler: 'handler',
  // 经办员
  cashier: 'cashier',
  // 出纳员
  invoiceManager: 'invoiceManager' // 系统开票
};
const mutations = {
  CHANGE_SETTING: (state, {
    key,
    value
  }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  }
};
const actions = {
  changeSetting({
    commit
  }, data) {
    commit('CHANGE_SETTING', data);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};